
<!DOCTYPE html>
<!--
This is a starter template page. Use this page to start your new project from
scratch. This page gets rid of all links and provides the needed markup only.
-->



<html lang="en">

<style>

  .center {
      margin-left: auto;
      margin-right: auto;
      display: block;
      height:200px;
      width: 600px;
  }
  .centerdiv {
      margin-left: auto;
      margin-right: auto;
      display: block;
      text-align: center;
      background-color: black;
  }
  .backgroundDiv{
    text-align: center;
  opacity: 0.9;
  }
  </style>



<app-sidebar-ecomerce></app-sidebar-ecomerce>

<div class="wrapper">
  
  <!-- Navbar -->
 
  <nav class="main-header navbar navbar-expand navbar-white navbar-light" style="height: 80px;" >
    <!-- Left navbar links -->
   

    <!-- Right navbar links -->
    <ul class="navbar-nav lg-auto"  >
     
        <li class="nav-item" *ngIf="ocultarCarrito == false" >
          <a class="nav-link" data-widget="pushmenu"   role="button" style="height: 50px;">
            <i class="fas fa-bars" style="font-size: 34px;color:rgba(7, 7, 7, 0.638);margin-top: -6px; height: 48px;width: auto;"></i>
          </a>
        </li>
 
      

      <!-- Navbar Search -->
      <li class="nav-item">
        <a class="nav-link" data-widget="navbar-search" role="button" (click)="OnHabilitarBusqueda()" *ngIf="ocultarCarrito == false"  style="width: 48px;height: 48px;" >
          <i class="fas fa-search"style="font-size: 32px; color:rgba(7, 7, 7, 0.638); margin-top: -6px; " ></i>
        </a>
        <div class="navbar-search-block" >
          <form class="form-inline"  [formGroup]="formBuscar" >
            <div class="input-group input-group-sm" >
              <input class="form-control form-control-navbar" type="text"  aria-label="Search" style="font-size: 20pt;height: 48px;border: 2px solid #0A0A0A; color: #0b0b0b;font-weight: bold;background-color: #FFFFFF;;height: 52px;" formControlName="txtBuscar" (keyup.enter)="OnBuscarAll()" >
              <div class="input-group-append">
                <button class="btn btn-navbar" type="button"  (click)="OnBuscarAll()"   style="border: 2px solid #424949;"  >
                  <i class="fas fa-search" style="font-size: 36px;"></i>
                </button>
                <button class="btn btn-navbar" type="button" data-widget="navbar-search"  (click)="OnCerrarBusqueda()" style="border: 2px solid #424949;">
                  <i class="fas fa-times" style="font-size: 36px;"></i>
                </button>
              </div>
            </div>
          </form>
        </div>
      </li>

    

    </ul>
    
   
    
    <ul    class="navbar-nav ml-auto">
      <li  class="nav-item" >
    
        <div >
          <img src="./assets/dist/img/titulo_andrea.png"  width="150" height="35" />
         </div>
   
      
      </li>  

    </ul>

    <ul    class="navbar-nav ml-auto">

      



      <li  class="nav-item dropdown" *ngIf="tieneSession == true" >

        <a class="nav-link" data-toggle="dropdown" href="#" *ngIf="ocultarCarrito == false">
     

            <img src="./assets/dist/img/user.png"  width="auto" height="42px" style="margin-top: -16px;margin-right: -12px;"  />

     
          
        </a>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
          <a href="#" class="dropdown-item">
            <!-- Message Start -->
            <div class="media">
            
              <div class="media-body">
                <h3 class="dropdown-item-title">
                  {{nombreCuenta}}
                  <span class="float-right text-sm text-danger"><i class="fas fa-star"></i></span>
                </h3>
                
              </div>
            </div>
            <!-- Message End -->
          </a>
          <div class="dropdown-divider"></div>
          <a  class="dropdown-item" (click)="logout()">
            <!-- Message Start -->
            <div class="media">
             
              <div class="media-body">
                <h3 class="dropdown-item-title">
                Cerrar sesión
                  <span class="float-right text-sm text-muted"><i class="fas fa-star"></i></span>
                </h3>
                
              </div>
            </div>
            <!-- Message End -->
          </a>
         
         
          
        </div>

      </li>

      <li  class="nav-item"    *ngIf="ocultarCarrito == false" style="margin-right: 8px;margin-top: -8px;">
        <a href="#/carrito">
        <img src="./assets/dist/img/carro.png"  width="auto" height="46"   />
        </a>
      </li>
  
      <span style="color: rgb(50, 50, 50);font-size: 35px;font-weight:bold">{{CantidadItem}}</span>

        <!-- <a  href="#/carrito">
          <img  src="./assets/dist/img/carro.png" width="auto" height="54px"  >
        
        </a> -->
      
    


  <!-- <a class="btn btn-danger btn-lg" href="#/carrito" style="color:rgb(255, 255, 255); background-image: url('./assets/dist/img/carro.png');background-color: transparent;background-size: 100% 100%;border-color: transparent;width: 52px; height: 52px;font-size: x-large;text-align: right;margin: 6px">
  {{countpedido}}   
   
</a> -->




     


     


    </ul>
   

  




  </nav>


  <!-- /.navbar -->


  
 

  <div  #myModal class="modal fade" data-backdrop="static" data-keyboard="false" id="modal-sm">
    <div class="modal-dialog" >
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">www.andreagt.com</h4>
          
        </div>

        <div  *ngIf="idTipoTransaccionDTO == 1">
          <div class="modal-body" style="text-align: center;">
          <img src="./assets/dist/img/neonet.jpg" width="25%"   style="opacity: .9"> 
          <h6 style="color: black; font-size: 12PX; font-family:'Courier New', Courier, monospace">{{nombreEmpresaDTO}}</h6>
          <h6 style="color: black; font-size: 12PX; font-family:'Courier New', Courier, monospace">{{direccionEmpresaDTO}}</h6>
          <h6 style="color: black; font-size: 12PX; font-family:'Courier New', Courier, monospace">AF. {{afiliacionNeoNetDTO}}</h6>
          <h6 style="color: black; font-size: 12PX; font-family:'Courier New', Courier, monospace">Guatemala C.A.  {{dateLocalTransDTO | date:'dd/MM/yyyy' }} {{timeLocalTransDTO   }}    No.{{sysTraceNo}}</h6>
          <h6 style="color: black; font-size: 12PX; font-family:'Courier New', Courier, monospace">REF {{retrievalResponseDTO}} AUT {{authResponseDTO}}</h6>
          <h6 style="color: black; font-size: 12PX; font-family:'Courier New', Courier, monospace">No. TARJETA {{noTarjetaDTO}} EXP: XX/XX</h6>
          <h6 style="color: black; font-size: 12PX; font-family:'Courier New', Courier, monospace">NOMBRE TARJETA {{nombreTarjetaDTO}}</h6>
          <br>
          <p  style="color: black; font-size: 18PX; font-family:'Courier New', Courier, monospace">COMPRA: <strong>  {{granTotalDTO | currency: 'Q'}}</strong></p> 
          <br>
          <div  *ngIf="cuotaDTO != '00' ">
            <p  style="color: black; font-size: 18PX; font-family:'Courier New', Courier, monospace">CUOTAS: <strong>  {{cuotaDTO}}</strong></p> 
            <br>

          </div>
            <h6 style="color: black; font-size: 14PX; font-family:'Courier New', Courier, monospace">(01) PAGADO ELECTRONICAMENTE !!</h6>
            </div>
      </div>


      <div  *ngIf="idTipoTransaccionDTO == 2">
          <div class="modal-body" style="text-align: center;">
          
          <img src="./assets/dist/img/neonet.jpg" width="25%"   style="opacity: .9"> 

          
          <h6 style="color: black; font-size: 16PX; font-family:'Courier New', Courier, monospace">VOUCHER DE ANULACIÓN</h6>
       
          <h6 style="color: black; font-size: 12PX; font-family:'Courier New', Courier, monospace">{{nombreEmpresaDTO}}</h6>
          <h6 style="color: black; font-size: 12PX; font-family:'Courier New', Courier, monospace">{{direccionEmpresaDTO}}</h6>
          <h6 style="color: black; font-size: 12PX; font-family:'Courier New', Courier, monospace">AF. {{afiliacionNeoNetDTO}}</h6>
          <h6 style="color: black; font-size: 12PX; font-family:'Courier New', Courier, monospace">Guatemala C.A.  {{dateLocalTransDTO | date:'dd/MM/yyyy' }} {{timeLocalTransDTO }}    No.{{sysTraceNo}}</h6>
          <h6 style="color: black; font-size: 12PX; font-family:'Courier New', Courier, monospace">REF {{retrievalResponseDTO}} AUT {{authResponseDTO}}</h6>
          <h6 style="color: black; font-size: 12PX; font-family:'Courier New', Courier, monospace">No. TARJETA {{noTarjetaDTO}} EXP: XX/XX</h6>
          <h6 style="color: black; font-size: 12PX; font-family:'Courier New', Courier, monospace">NOMBRE TARJETA {{nombreTarjetaDTO}}</h6>
          <br>
          <p  style="color: black; font-size: 18PX; font-family:'Courier New', Courier, monospace">COMPRA: <strong> {{granTotalDTO | currency: 'Q -'}}</strong></p> 
          <br>
          <h6 style="color: black; font-size: 14PX; font-family:'Courier New', Courier, monospace">(01) PAGADO ELECTRONICAMENTE !!</h6>
            </div>
      </div>

     

          <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-info" (click)="OnContinuar()" >Continuar</button>
        
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>













  <div class="content-header">
    <div class="container">
      <div class="row mb-2">
        <div class="col-sm-10">
          <video [autoplay]="true" [muted]="true" [loop]="true" [playsInline]="true" [controls]="true" width="100%" height="100%">
            <source [src]="'./assets/dist/img/andreabanner.mp4'" type="video/mp4" />
            
          </video>
        </div>
        
      </div><!-- /.row -->
    </div><!-- /.container-fluid -->
  </div>


  <div class="content">
    <div class="container">

      
      <div class="row">
          <div class="col-sm-10">
            <form  >
              <div *ngIf="modoBusqueda== false ">
            <div class="card card-warning">
              <div class="card-header">
                <h3 class="card-title">Pedidos realizados </h3>
              </div>
              <!-- /.card-header -->
              <div class="card-body">



                <div class="card-body pt-0" *ngFor="let dato of pedidoCliente; let i=index">
                  <div class="row">
                    <div class="col-7">
                      <h2 class="lead" style="color:gray;"><b>Fecha: {{dato.fecha | date:'dd-MM-yyyy'}} </b></h2>
                      <table class="table">
                        <tr >
                          <td class="text-muted text-bold">No. Pedido: </td>
                          <td class="text-muted text-sm" style="text-align: center;"> {{dato.idPedido}}</td>
                        </tr>
                        <tr>
                          <td class="text-muted text-bold">Forma Pago:</td>
                          <td class="text-muted text-sm">{{dato.formaPago}}</td>
                        </tr>

                        
                        <tr>
                          <td class="text-muted text-bold">Estado:</td>
                          <td class="text-muted text-sm">{{dato.estado}}</td>
                        </tr>

                        <tr>
                          <td class="text-muted text-bold">Total:</td>
                          <td class="text-muted text-sm" style="text-align: center;">{{dato.total | currency: 'Q'}}</td>
                        </tr>

                      
                      </table>

                    </div>
                    
                  </div>
                  <div class="text-left">
                    <a class="btn btn-sm btn-danger" (click)="OnVerDetallePedido(dato.idPedido,-1)">
                     Ver Detalle
                    </a>
                    <a class="btn btn-sm btn-success" (click)="OnVerPagoElectronico(dato.idPedido,-1,dato.idFormaPago)">
                      Ver Pago Electrónico
                     </a>
                  </div>
                  <br>
                  <br>
               
                </div>















             



              </div>
            </div>

          
            <div class="card card-success">
              <div class="card-header">
                <h3 class="card-title">Detalle del pedido </h3>
              </div>
              <!-- /.card-header -->
              <div class="card-body">








              <div class="card-body pt-0" *ngFor="let dato of detallePedidoDTO; let i=index">
                      <div class="row">
                        <div class="col-7">
                          <h2 class="lead" style="color:gray;"><b> {{dato.modelo}}</b></h2>
                          <table class="table">
                            <tr >
                              <td class="text-muted text-bold">Cantidad: </td>
                              <td class="text-muted text-sm" style="text-align: center;"> {{dato.cantidad}}</td>
                            </tr>
                            <tr>
                              <td class="text-muted text-bold">Talla:</td>
                              <td class="text-muted text-sm">{{dato.talla}}</td>
                            </tr>
    
                            <tr>
                              <td class="text-muted text-bold">Color:</td>
                              <td class="text-muted text-sm">{{dato.colorErp}}</td>
                            </tr>
    
                            <tr>
                              <td class="text-muted text-bold">Importe:</td>
                              <td class="text-muted text-sm" style="text-align: center;">{{dato.importe | currency: 'Q'}}</td>
                            </tr>
    
                            <tr>
                              <td class="text-muted text-bold">Estado:</td>
                              <td class="text-muted text-sm">{{dato.estado}}</td>
                            </tr>
                          </table>
    
                        </div>
                        <div class="col-5 text-center">
                          <img src={{urlServerUpload$}}{{dato.imagen}}{{tipoMedia$}} alt="user-avatar" class="img-circle img-fluid" style="height: auto;width: 80%;" >
                        </div>
                      </div>
                     
                     
                    </div>



                    <div class="text-center">
                      <a class="btn btn-sm btn-success" (click)="OnRegresar()" >
                        <i class="fas fa-chevron-down"></i> Regresar
                      </a>
                    </div>



                </div>
           
    </div>


  </div>

            <div *ngIf="modoBusqueda== true ">

              <div class="card card-warning">
                <div class="card-header">
                  <h3 class="card-title">Pedidos realizados </h3>
                </div>
             
                <div class="card-body">


            <div class="row"   infiniteScroll
            [infiniteScrollDistance]="2"
            [infiniteScrollThrottle]="50"
            (scrolled)="onScroll()">
             

        
                <div class="col-6 col-sm-6 col-md-4 align-items-stretch " *ngFor="let datos  of content" >
                  <div class="card-body pt-0"  (click)="OnSelectProducto(datos.idProducto)">
                    <div class="row">
                     
                      <div class="text-center">
                        <img class="img-fluid"
                        src={{urlServerUpload$}}{{datos.imagen}}{{tipoMedia$}}
                             alt="User profile picture" style="height: 110%;width: 110%;">
                      </div>
                      <div class="col-8">
                        <label class="text-muted text-sm">{{datos.modelo}}</label><br>
                        <label class="text-muted text-sm">{{datos.descripcion}}</label>
                        <p class="text-muted text-sm"><b>Precio: </b> {{datos.precio | currency: 'Q'}}</p>
                      </div>
                      <div class="col-8" >
                     </div>
                    </div>
                  </div>
                </div>
    
             
                
          
            </div>

          </div>
        </div>
      </div>

            </form>
        </div>
    </div>
</div> 
</div>
       






  
    <!-- /.content -->

    <app-footer-sucursal-ecomerce></app-footer-sucursal-ecomerce>
      
   
  </div>
  <!-- /.content-wrapper -->

  <!-- Control Sidebar -->
  <aside class="control-sidebar control-sidebar-dark">
    <!-- Control sidebar content goes here -->

  </aside>
  <!-- /.control-sidebar -->


 


  <!-- Main Footer -->
<app-footer-ecomerce></app-footer-ecomerce>



  



</html>
